<template>
  <div>
    <b-card>
      <div
        class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
      >
        <h3 class="mt-1">
          <feather-icon
            icon="UsersIcon"
            class="mr-50"
            style="width: 18px; height: 18px"
          />
          <span>Partners</span>
        </h3>
        <!-- <div class="d-flex">
          <b-button
            class="gradient-btn mt-1 nowrap-white-space"
            @click="visibleCreatePartner = true"
          >
            <feather-icon icon="PlusIcon" />
            <span> Create a partner</span></b-button
          >
        </div> -->
      </div>
      <b-form
        @submit.prevent="filter"
        class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
      >
        <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
          <v-select
            :options="types"
            v-model="type"
            label="label"
            :reduce="(option) => option.value"
            :searchable="false"
            placeholder="Display on the page"
            class="w-100"
          ></v-select>
        </div>

        <div class="col-sm-6 col-12 d-flex align-items-center p-50">
          <b-form-input
            placeholder="search"
            v-model.trim="search"
            :disabled="!type"
          />
        </div>
        <div class="col-sm-3 col-12 p-50">
          <b-button class="w-100" type="submit" :disabled="!search">
            <span class="text-muted h5"> Filtering</span>
          </b-button>
        </div>
      </b-form>

      <data-table :fields="fields" :items="partners" :loading="loading">
        <template #selectpartners="{ data }">
          <div class="d-flex">
            <div class="pr-50 border-right mr-75">
              <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
            </div>
          </div>
        </template>

        <template #name="{ data }">
          <span style="white-space: nowrap">
            <b-avatar
              size="40"
              variant="light-primary"
              rounded="avatar"
              style="border: 2px solid #73747e !important"
              :src="data.item.logo"
            />
            {{ data.item.name || "-" }}
          </span>
        </template>
        <template #email="{ data }">
          {{ data.item.email || "-" }}
        </template>
        <template #mobile="{ data }">
          {{ data.item.mobile || "-" }}
        </template>
        <template #country="{ data }">
          <div style="height: 35px; width: 40px" v-if="data.item.flag_url">
            <b-img
              class="rounded-circle"
              style="height: 30px !important"
              width="30"
              :src="data.item.flag_url || errorImage"
              @error="setAltImg"
              fluid
            />
          </div>
          <span v-else>-</span>
        </template>

        <template #company_name="{ data }">
          {{ data.item.company_name || "-" }}
        </template>
        <template #business_scale="{ data }">
          {{ data.item.business_scale || "-" }}
        </template>

        <template #actions="{ data }">
          <div class="nowrap-white-space">
            <b-dropdown no-caret class="d-flex d-xl-none more-option">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" />
              </template>
              <b-dropdown-item
                variant="flat-danger"
                :to="{
                  name: 'documents-show',
                  params: {
                    id: data.item.id,
                  },
                }"
                v-if="userData.type === 'admin'"
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="EditIcon" class="mr-50" />documents
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                variant="flat-primary"
                @click="
                  showChangeStatus = true;
                  currentData = data;
                "
                v-if="userData.type === 'admin'"
              >
                <div class="d-flex align-items-center w-100">
                  <feather-icon icon="EditIcon" class="mr-50" /> Change status
                </div>
              </b-dropdown-item>
            </b-dropdown>
            <div class="d-xl-flex d-none">
              <b-button
                variant="flat-danger"
                class="mx-25"
                :to="{
                  name: 'documents-show',
                  params: {
                    id: data.item.id,
                  },
                }"
                v-if="userData.type === 'admin'"
                ><feather-icon icon="EditIcon" />documents</b-button
              >
              <b-button
                variant="flat-primary"
                class="mx-25"
                @click="
                  showChangeStatus = true;
                  currentData = data;
                "
                v-if="userData.type === 'admin'"
                ><feather-icon icon="EditIcon" /> Change status</b-button
              >
            </div>
          </div>
        </template>
      </data-table>

      <div
        class="w-100 d-flex flex-wrap align-items-center justify-content-between"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-card>
    <partners-change-status-modal
      :showChangeStatus="showChangeStatus"
      v-model="showChangeStatus"
      :currentData="currentData"
      @updatePartners="getPartners"
    />
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  BImg,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PartnersChangeStatusModal from "../../partners/patners-change-status-modal/PartnersChangeStatusModal.vue";
import VSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    BImg,
    VSelect,
    PartnersChangeStatusModal,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      userData: this.$store.state.auth.userData,
      selectAll: false,
      removePartnersDataData: [],
      showChangeStatus: false,
      url: "/panel/partners",
      pages: [],
      currentData: {},
      selectedPage: "",
      currentPage: 1,
      types: [
        { label: "Full Name", value: "name" },
        { label: "Email", value: "email" },
        { label: "Mobile", value: "mobile" },
        { label: "Company name", value: "company_name" },
        // { label: "Business Scale", value: "business_scale" },
      ],
      type: "",
      search: "",
      loading: false,
      pagination: {},
      fields: [
        { key: "selectpartners", label: "Row" },
        { key: "name", label: "Full Name" },
        { key: "email", label: "Email" },
        { key: "mobile", label: "Mobile" },
        { key: "country", label: "Country" },
        { key: "company_name", label: "Company name" },
        { key: "business_scale", label: "Business Scale" },
        { key: "actions", label: "Operation" },
      ],
      partners: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      let filter = {};
      if (this.$route.fullPath != "/documents") {
        this.$router.push({
          name: "documents",
          query: {},
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "documents",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "documents",
            query: {
              filter,
            },
          });
        }
      }
    },
    $route: {
      handler(val) {
        this.removePartnersDataData = [];
        this.getPartners();
      },
      immediate: true,
      deep: true,
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removePartnersDataData = this.partners.map(
              (partner) => partner.id
            ))
          : (this.removePartnersDataData = []);
      },
      immediate: true,
    },
    removePartnersDataData: {
      handler(val) {
        val.length == this.partners.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "documents",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        filter[this.type] = this.search;
        this.$router.push({
          name: "documents",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/documents") {
        this.$router.push({
          name: "documents",
        });
      }
    },
    removePartner(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/partners/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removePartnersDataData = [];
                await this.getPartners();
              } else {
                await this.$router.push({
                  name: "partners",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removePartnersData() {
      if (this.removePartnersDataData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removePartnersDataData.map(
                  async (faq) =>
                    await this.$http.delete(`/panel/partners/${faq}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removePartnersDataData = [];
                  await this.getPartners();
                } else {
                  await this.$router.push({
                    name: "partners",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getPartners() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          filter: {
            ...this.$route.query.filter,
            has_document: 1,
          },
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.partners = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style scoped>
@media (max-width: 576px) {
  .btn {
    padding: 14px 5px;
  }
  .btn > span {
    font-size: 12px !important;
  }
  h3 {
    font-size: 18px !important;
  }
}
</style>
